import React, { Component } from 'react';

class DonationSuccess extends Component {
  render() {
    return (
      <main className="app-body">
        <div className="message-box">
          <h3>Il Tinabalike è andato a buon fine</h3>
          <svg width="60px" height="60px" viewBox="0 0 60 60" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>TinabaLike/Ok</title>
            <desc>Created with Sketch.</desc>
            <defs></defs>
            <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="TinabaLike/Ok" fill="#44AE75">
                <path d="M30,56 C15.6405965,56 4,44.3594035 4,30 C4,15.6405965 15.6405965,4 30,4 C44.3594035,4 56,15.6405965 56,30 C56,44.3594035 44.3594035,56 30,56 Z M30,52 C42.1502645,52 52,42.1502645 52,30 C52,17.8497355 42.1502645,8 30,8 C17.8497355,8 8,17.8497355 8,30 C8,42.1502645 17.8497355,52 30,52 Z" id="Combined-Shape"></path>
                <rect id="Rectangle-17" transform="translate(22.960786, 33.113961) rotate(-315.000000) translate(-22.960786, -33.113961) " x="16.3143398" y="31.113961" width="13.2928932" height="4"></rect>
                <rect id="Rectangle-17" transform="translate(32.875604, 30.234677) rotate(-45.000000) translate(-32.875604, -30.234677) " x="21.8157986" y="28.2346771" width="22.1196113" height="4"></rect>
              </g>
            </g>
          </svg>
        </div>
      </main>
    );
  }
}

export default DonationSuccess;



/** WEBPACK FOOTER **
 ** ./src/components/DonationSuccess.jsx
 **/